import styles from './styles.module.scss';

import { SchoolCourse } from '../../../../../../types';
import { Input } from '../../../../../../components/Input';
import { FormControl } from '../../../../../../components/FormControl';
import { Button } from '../../../../../../components/Button';

type LogicManagerCourseDetailProps = {
    course: SchoolCourse | undefined;
    setCourse: React.Dispatch<React.SetStateAction<SchoolCourse | undefined>>;
    onSave: React.MouseEventHandler<HTMLButtonElement>;
    onAdd: React.MouseEventHandler<HTMLButtonElement>;
    onDelete: React.MouseEventHandler<HTMLButtonElement>;
};

export const LogicManagerCourseDetail = ({
    course,
    setCourse,
    onSave,
    onAdd,
    onDelete
}: LogicManagerCourseDetailProps) => {
    const onFormControlChange = (event: any, prop: string) => {
        if (course) {
            course[prop] = event.target.value;

            setCourse({ ...course });
        }
    };

    return (
        <div className={styles.wrapper}>
            {course ? (
                <>
                    <div className={styles.btnBox}>
                        <Button type='success' title='Adicionar' onClick={onAdd}>
                            <div className='fa fa-plus' aria-hidden='true' />
                        </Button>

                        <div className={styles.btnBoxGroup}>
                            <Button type='error' title='Excluir' onClick={onDelete}>
                                <div className='fa fa-trash' aria-hidden='true' />
                            </Button>
                            <Button type='success' title='Salvar' onClick={onSave}>
                                <div className='fa fa-check' aria-hidden='true' />
                            </Button>
                        </div>
                    </div>

                    <div className={styles.container}>
                        <FormControl
                            key='formControlName'
                            flexDirection='column'
                            wrapperClass={styles.five}
                            label='Nome'
                            inputId='name'
                        >
                            <Input
                                key='inputName'
                                inputWrapperClass={styles.field}
                                id='name'
                                type='text'
                                value={course.name}
                                onChange={(e: any) => onFormControlChange(e, 'name')}
                            />
                        </FormControl>

                        <FormControl
                            key='formControlSlug'
                            flexDirection='column'
                            wrapperClass={styles.five}
                            label='Sigla'
                            inputId='slug'
                        >
                            <Input
                                key='inputSlug'
                                inputWrapperClass={styles.field}
                                id='slug'
                                type='text'
                                value={course.slug}
                                onChange={(e: any) => onFormControlChange(e, 'slug')}
                            />
                        </FormControl>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.btnBox}>
                        <Button type='success' title='Adicionar' onClick={onAdd}>
                            <div className='fa fa-plus' aria-hidden='true' />
                        </Button>
                    </div>

                    <div className={styles.noSelected}>Selecione um curso</div>
                </>
            )}
        </div>
    );
};
